import { type ReactNode } from 'react';
import { css } from '@emotion/css';
import { VStack } from '@cbhq/cds-web/layout';

const LayoutWrapperStyles = css`
  min-height: 100vh;
  position: relative;

  &:before {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: block;
    content: '';
    z-index: -1;

    background-size:
      6px 6px,
      100% 100%;
    background-repeat: repeat, no-repeat;

    /* Add mask-image to fade from transparent to 50% opacity */
    mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 33%, rgba(0, 0, 0, 1) 66%);
    -webkit-mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 33%, rgba(0, 0, 0, 1) 66%);
  }

  /* Light mode receives more subtle dots and underlying gradient */
  [data-theme='light'] &:before {
    background-image: url("data:image/svg+xml,%3Csvg width='10' height='10' viewBox='0 0 10 10' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%230052ff' fill-opacity='0.2' fill-rule='evenodd'%3E%3Ccircle cx='2.5' cy='2.5' r='1.5'/%3E%3Ccircle cx='7.5' cy='7.5' r='1.5'/%3E%3C/g%3E%3C/svg%3E"),
      linear-gradient(to bottom, rgba(var(--blue60), 0) 66%, rgba(var(--blue60), 0.1) 100%);
  }

  /* Dark mode has more pronounced dots and end gradient opacity */
  [data-theme='dark'] &:before {
    background-image: url("data:image/svg+xml,%3Csvg width='10' height='10' viewBox='0 0 10 10' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%230052ff' fill-opacity='0.4' fill-rule='evenodd'%3E%3Ccircle cx='2.5' cy='2.5' r='1.5'/%3E%3Ccircle cx='7.5' cy='7.5' r='1.5'/%3E%3C/g%3E%3C/svg%3E"),
      linear-gradient(to bottom, rgba(var(--blue60), 0) 66%, rgba(var(--blue60), 0.3) 100%);
  }

  &:after {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: block;
    content: '';
    z-index: -2;

    background: var(--color-bg);
  }
`;

type Props = {
  children: ReactNode;
};

function LayoutWrapper({ children }: Props) {
  return <VStack className={LayoutWrapperStyles}>{children}</VStack>;
}

export { LayoutWrapper };
